import {all, call, put, takeLatest} from 'redux-saga/effects'
import {sessionLoginAttempt} from 'actions/auth'
import types from '../actions/types'
import {
  loadBillingDetailsFailure,
  loadBillingDetailsSuccess,
  updateBillingDetailsFailure,
  updateBillingDetailsSuccess,
} from 'actions/account'
import {loadAccountPackages, loadCurrencies} from 'actions/data'
import {generalError} from 'actions/index'
import {snackbarMessage} from 'actions/snackbar'
import {setLocale} from 'actions/settings'
import * as signUpFinal from 'actions/signUpFinal'
import {finaliseFailure, finaliseSuccess} from 'actions/signUpFinal'
import iconNames from 'theme/icons'

export default (api) => {

  function* accountPlanCancelSuccess() {
    try {
      yield put(sessionLoginAttempt())
      yield put(loadAccountPackages())
      yield put(snackbarMessage('Your 30-day cancellation period begins now', iconNames.tick, true))
    } catch (e) {
      console.error(e)
      yield put(generalError('Failed to cancel account - please contact Clarity Support to cancel'))
    }
  }

  function* accountPlanCancelFailure(info) {
    console.error(info)
    yield put(generalError('Failed to cancel account - please contact Clarity Support to cancel'))
  }

  function* loadBillingDetails() {
    try {
      const response = yield call(api.billingDetails.get)
      yield api.handleResponse(
          response,
          function* onOK(key, data) {
            const details = data.result
            yield put(loadBillingDetailsSuccess(details))
          },
          function* onFail(key, message, code) {
            yield put(loadBillingDetailsFailure(message, code))
          })
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* updateBillingDetails({billingDetails}) {
    try {

      const params = {billingDetails}
      const response = yield call(api.billingDetails.update, params)
      yield api.handleResponse(
          response,
          function* onOK(key, data) {
            const details = data.result
            yield put(updateBillingDetailsSuccess(details))
            yield put(snackbarMessage('Your billing details have been updated.', iconNames.tick))
          },
          function* onFail(key, message, code) {
            yield put(updateBillingDetailsFailure(message, code))
          })
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* finaliseAccount({data}) {
    try {
      const {locale, currency} = data
      if (locale) yield put(setLocale(locale))

      const response = yield call(api.finaliseAccount, {currency})
      yield api.handleResponse(
          response,
          function* onOK() {
            yield put(finaliseSuccess(data))
            yield put(loadCurrencies())
          },
          function* onFail(key, message, code) {
            yield put(finaliseFailure(message, code))
            yield put(snackbarMessage('Sorry, there was a problem saving your changes', iconNames.error))
          })
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* watcher() {
    yield all([
      takeLatest(types.BILLING_DETAILS_LOAD_ATTEMPT, loadBillingDetails),
      takeLatest(types.BILLING_DETAILS_UPDATE_ATTEMPT, updateBillingDetails),
      takeLatest(types.CANCEL_PLAN_SUCCESS, accountPlanCancelSuccess),
      takeLatest(types.CANCEL_PLAN_FAILURE, accountPlanCancelFailure),
      takeLatest(signUpFinal.types.FINALISE_ATTEMPT, finaliseAccount),
    ])
  }

  return {
    watcher,
  }
}
